import { render, staticRenderFns } from "./AccredInfoList.vue?vue&type=template&id=fc256d10&scoped=true&"
import script from "./AccredInfoList.vue?vue&type=script&lang=js&"
export * from "./AccredInfoList.vue?vue&type=script&lang=js&"
import style0 from "./AccredInfoList.vue?vue&type=style&index=0&id=fc256d10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc256d10",
  null
  
)

export default component.exports